// extracted by mini-css-extract-plugin
export var subtitle = "_d1-2";
export var title = "_d1-0";
export var titleNoWrap = "_d1-1";